import Api from "@/services/service-v2";

export const createQuestionSet = (payload) =>
  Api().$http.post(`/survey/api/question-sets`, payload);
export const createQuestion = (payload) =>
  Api().$http.post(`/survey/api/questions`, payload);
export const fetchQuestionSet = () =>
  Api().$http.get(`/survey/api/question-sets`);
export const addRewards = (payload) =>
  Api().$http.post(`/survey/api/rewards`, payload);
export const employeeFeedbackList = (id) =>
  Api().$http.get(`/survey/api/answers?set=${id}&group=y`);
export const employeeFeedbackDetails = (payload) =>
  Api().$http.get(`/survey/api/answers?set=${payload.id}&user=${payload.userId}`);
export const getQuestions = (id) =>
  Api().$http.get(`/survey/api/questions?set=${id}`);
export const updateQuestion = (payload) =>
  Api().$http.put(`/survey/api/questions/${payload.id}`, payload.data);
export const deleteQuestion = (id) =>
  Api().$http.delete(`/survey/api/questions/${id}`);